const modal = () => {
  const modal = document.getElementById('js-modal'),
    openModalBtns = document.querySelectorAll('.js-open-modal-btn'),
    closeModalBtns = document.querySelectorAll('.js-close-modal-btn'),
    html = document.getElementsByTagName('html')[0]

  if (modal) {
    const modalTitle = modal.querySelector('#dialogTitle'),
      modalDesc = modal.querySelector('#dialogDesc'),
      modalImg = modal.querySelector('#dialogImg'),
      modalEmail = modal.querySelector('.gfield--type-hidden .gform_hidden')

    console.log(modalEmail)
  }

  openModalBtns &&
    openModalBtns.forEach((openModalBtn) => {
      openModalBtn.addEventListener('click', (e) => {
        changeModalState(openModalBtn, false)
      })
    })

  closeModalBtns &&
    closeModalBtns.forEach((closeModalBtn) => {
      closeModalBtn.addEventListener('click', (e) => {
        changeModalState(closeModalBtn, true)
      })
    })

  modal &&
    modal.addEventListener('animationend', () => {
      modal.classList.remove('js-transition-in')
      modal.classList.remove('js-transition-out')
    })

  const changeModalText = (elm, text) => {
    if (!text) return elm.classList.add('hidden')

    elm.classList.remove('hidden')
    elm.innerHTML = text
  }

  const changeModalImg = (elm, src, style) => {
    if (!src && !style) return elm.classList.add('hidden')

    elm.classList.remove('hidden')
    elm.querySelector('img').style.objectPosition = style
    elm.querySelector('img').src = src
  }

  const changeModalEmail = (elm, email) => {
    if (!email) return

    elm.value = email
    console.log(email)
  }

  const changeModalState = (btn, state) => {
    if (btn.ariaDisabled === 'true') return

    modal.ariaHidden = state

    closeModalBtns.forEach((btn) => (btn.ariaDisabled = state))
    openModalBtns.forEach((btn) => (btn.ariaDisabled = !state))

    if (modal.classList.contains('js-active')) {
      modal.classList.add('js-transition-out')
    } else if (modal.classList.contains('js-inactive')) {
      modal.classList.add('js-transition-in')

      changeModalText(modalTitle, btn.dataset.heading)
      changeModalText(modalDesc, btn.dataset.subheading)
      changeModalImg(modalImg, btn.dataset.imgSrc, btn.dataset.imgFocus)
      changeModalEmail(modalEmail, btn.dataset.email)
    }

    modal.classList.toggle('js-active')
    modal.classList.toggle('js-inactive')
    html.classList.toggle('js-noscroll')
    html.classList.toggle('js-noscroll-mobile')
  }
}

export default modal
